module.exports = __webpack_public_path__ + "media/images/active_material/icons/arrow_down-3998cb92c4728b257d108e4af4b932b5.svg";